export const CDN_BRANCH_COOKIE_NAME = 'cdn_branch_override';
export const ORIG_BRANCH_COOKIE_NAME = 'orig_cdn_branch_override';
